import { render, staticRenderFns } from "./addCaseProduct.vue?vue&type=template&id=bd85cd40&lang=pug"
import script from "./addCaseProduct.vue?vue&type=script&lang=js"
export * from "./addCaseProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports